import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
  init: () => {
    const sections = document.querySelectorAll("[data-section-reveal]");

    sections.forEach((section) => {
      const sectionTitle = section.querySelector("[data-section-reveal-title]");
      const sectionContent = section.querySelector("[data-section-reveal-content]");
      const nextElement = section.nextElementSibling;
      const ignoreMobile = section.dataset.ignoreMobileReveal || false;

      const scrollTriggerConfig = {
        trigger: section,
        endTrigger: section,
      };

      if (!(ignoreMobile && window.innerWidth <= 768)) {
        scrollTriggerConfig.start = "top 60%";
        scrollTriggerConfig.end = "bottom 5%";
        scrollTriggerConfig.pin = true;
        scrollTriggerConfig.scrub = true;
      }

      const tl = gsap.timeline({
        scrollTrigger: scrollTriggerConfig,
      });

      tl.fromTo(
        sectionTitle,
        {
          yPercent: 100,
          xPercent: -50,
          opacity: 0,
        },
        {
          yPercent: 0,
          xPercent: 0,
          opacity: 1,
          duration: 1,
          ease: "power2.out",
        },
      );

      tl.fromTo(
        sectionContent,
        {
          yPercent: 100,
          xPercent: 50,
          opacity: 0,
        },
        {
          yPercent: 0,
          xPercent: 0,
          opacity: 1,
          duration: 1,
          ease: "power2.out",
        },
        "<",
      );
    });
  },
};
